import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Spinner from "../../LayOut/Spinner";
import { Button } from "devextreme-react";

import DataGrid, {
    Column,
    Pager,
    Paging,
    HeaderFilter,
    SearchPanel,
    Export,
    Lookup,
    Scrolling

} from "devextreme-react/data-grid";
import { loadMessages, locale, } from "devextreme/localization";
import { getReport } from "../../../apis/toowezeApi";
import states from "../../data/states";
import countries from "../../data/countries";
import { Link } from "react-router-dom";
import { Template } from "devextreme-react/core/template";
import Switch from "devextreme-react/switch";
import { i18n, lgMessages, languageCode, } from "../../../translate/i18n";
import "./ReportsViewMiddle.css";

class ReportsViewMiddle extends Component {

    constructor(props) {
        super(props);
        this.state = {
            datagrid: [],
            spinner: true,
            reportType: null,
            error: null,
            events: [],
            popupVisible: false,
            delimiter: ";",
            text: "",
            button: false,
            backgroundcolor: "white",
            loadPanelVisible: false,
            statusDisabled: false,
            showDelimiter: "",
            myDrops: []
        };
        this._requestSeq = 0;
        loadMessages(lgMessages);
        locale(languageCode);
    }

    getReportType(location = this.props.location) {
        return new URLSearchParams(location.search).get("type");
    }

    componentDidMount() {
        this.fetchReport(this.getReportType());
    }

    componentDidUpdate(prevProps) {
        const prevType = this.getReportType(prevProps.location);
        const nextType = this.getReportType(this.props.location);
        if (prevType !== nextType) {
            this.fetchReport(nextType);
        }
    }

    componentWillUnmount() {
        this._requestSeq += 1;
    }

    fetchReport(reportType) {
        const requestSeq = ++this._requestSeq;

        if (!reportType) {
            this.setState({
                datagrid: [],
                spinner: false,
                reportType: null,
                error: null,
            });
            return;
        }

        this.setState({
            spinner: true,
            reportType,
            error: null,
        });

        getReport(reportType)
            .then((rows) => {
                if (requestSeq !== this._requestSeq) {
                    return;
                }
                this.setState({
                    datagrid: rows,
                    spinner: false,
                    error: null,
                });
            })
            .catch((error) => {
                if (requestSeq !== this._requestSeq) {
                    return;
                }
                const message =
                    error?.response?.data?.msg ||
                    error?.message ||
                    "Não foi possível carregar o relatório.";
                this.setState({
                    datagrid: [],
                    spinner: false,
                    error: message,
                });
            });
    }

    setStatus(data) {
        if (data.data.status === "Active") {
            return (
                <span className="badge badge-success">
                    {
                        i18n.t("customers.grid.customerstatusactive")
                    } </span>
            );
        } else if (data.data.status === "Inactive" || data.data.status === 3 || data.data.status === "3" || data.data.status === "Deleted") {
            return (
                <span className="badge badge-danger">
                    {
                        i18n.t("customers.grid.customerstatusinactive")
                    } </span>
            );
        }
    }

    statusHeaderFilter = [
        {
            text: i18n.t("customers.grid.customerstatusactive"),
            value: ["status", "=", "Active"],
        },
        {
            text: i18n.t("customers.grid.customerstatusinactive"),
            value: ["status", "=", "Inactive"],
        },
    ];

    setGender(data) {
        if (data.data.gender === "1") {
            return (
                <span className="badge badge-primary" width="30px">
                    {
                        i18n.t("customers.grid.customergendermale")
                    } </span>
            );
        } else if (data.data.gender === "2") {
            return (
                <span className="badge badge-danger" width={3}>
                    {
                        i18n.t("customers.grid.customergenderfemale")
                    } </span>
            );
        } else {
            return (
                <span className="badge badge-info" width={3}>
                    {
                        i18n.t("customers.grid.customergendernot")
                    } </span>
            );
        }
    }

    genderHeaderFilter = [
        {
            text: i18n.t("customers.grid.customergendermaleheader"),
            value: ["gender", "=", "1"],
        },
        {
            text: i18n.t("customers.grid.customergenderfemalehearder"),
            value: ["gender", "=", "2"],
        },
    ];

    toolbarItemRender = () => {
        return (
            <Button id="import" icon="export"
                hint={
                    i18n.t("customers.grid.customershintlabel")
                }
                style={
                    { background: "#f9b831" }
                } />
        );
    };

    renderSwitch = (cellInfo) => {
        const setEditedValue = (valueChangedEventArg) => {
            cellInfo.setValue(valueChangedEventArg.value);
        };
        return (
            <div className=""
                style={
                    { paddingLeft: "6px" }
                }>
                <Switch width={50}
                    switchedOnText={i18n.t("customers.grid.customerstatusactive")}
                    switchedOffText={i18n.t("customers.grid.customerstatusinactive")}
                    defaultValue={
                        cellInfo.value
                    }
                    disabled={
                        cellInfo.row.values[3] === 0 || cellInfo.row.values[3] === 1 ? false : true
                    }
                    onValueChanged={setEditedValue} />
            </div>
        );
    };

    calculateCellValue2(data) {
        if (data) {
            if (data.createdAt) {
                return new Date(data.createdAt * 1000);
            }
        }
    }

    addCurrency = (data) => {
        if (data.value) {
            const value = data.value;
            const formattedValue = Number(value).toFixed(2);
            const withZero = formattedValue.includes('.') ? formattedValue : formattedValue + '0';
            return (
                <span style={{ fontWeight: 'bold' }}>{withZero}</span>

            );
        } else {
            return (<div>
                <label className="badge">n/a</label>
            </div>
            );
        }
    };


    activity(data) {
        return (
            <Link to={`addeditcustomers?id=${data.data._id}`}>
                {i18n.t("customers.grid.customerlabeldetails")}
            </Link>
        );
    }


    render() {
        const { spinner, reportType, error, datagrid } = this.state;

        return (
            <div className="container col-11"
                style={
                    {
                        marginLeft: "30px",
                        marginTop: "30px",
                    }
                }>

                <h1>{reportType === "allPoints" ? i18n.t("customers.grid.columnlabeltotalPoints") : i18n.t("customers.grid.columnlabeltotalCashBack")}</h1>

                {spinner && <Spinner />}

                {!spinner && error && (
                    <div className="alert alert-danger" role="alert">
                        {error}
                    </div>
                )}

                {!spinner && !error && datagrid.length === 0 && (
                    <div className="alert alert-info" role="alert">
                        Nenhum registro encontrado para este relatório.
                    </div>
                )}

                {!spinner && !error && (
                    <DataGrid dataSource={datagrid}
                        columnWidth={100}
                        showBorders={true}
                        allowColumnReordering={true}
                        allowColumnResizing={true}
                    >
                        <Scrolling mode="standard" />
                        <Paging defaultPageSize={12} />
                        <Pager showInfo={true} />
                        <HeaderFilter visible={true} />
                        <SearchPanel visible={true}
                            className="custom"
                            width={240}
                            placeholder={
                                i18n.t("customers.grid.searchplaceholder")
                            } />

                        <Column
                            dataField="seeActivity"
                            caption={i18n.t("customers.grid.customerlabeldetails")}
                            cellRender={this.activity}
                            allowFiltering={false}
                        />

                        <Column dataField="name" width={200} caption={i18n.t("customers.grid.columnlabelname")} />
                        <Column dataField="email" width={200} caption={i18n.t("customers.grid.columnlabelemail")} />

                        <Column dataField="mobil" caption={i18n.t("customers.grid.columnlabelmobil")} />
                        <Column dataField="total" caption={reportType === "allPoints" ? i18n.t("customers.grid.columnlabeltotalPoints") : i18n.t("customers.grid.columnlabeltotalCashBack")} cellRender={this.addCurrency} />

                        <Column dataField="gender"
                            caption={
                                i18n.t("customers.grid.columnlabelgender")
                            }
                            cellRender={
                                this.setGender
                            }
                            editCellRender={
                                this.renderSwitch
                            }

                        ><HeaderFilter dataSource={this.genderHeaderFilter} /></Column>

                        <Column dataField="externalID" caption={i18n.t("customers.grid.columnlabelexternalID")} />
                        <Column dataField="birthDay" dataType="date" caption={i18n.t("customers.grid.columnlabelbirthDay")} />
                        <Column dataField="address.cityName" caption={i18n.t("customers.grid.columnlabelcityName")} />
                        <Column dataField="regionId" caption={i18n.t("customers.grid.columnlabelregionName")}>
                            <Lookup dataSource={states} valueExpr="id" displayExpr="nome" />
                        </Column>

                        <Column dataField="countryId" caption={i18n.t("customers.grid.columnlabelcountryName")}>
                            <Lookup dataSource={countries} valueExpr="id" displayExpr="name" />
                        </Column>
                        <Column dataField="tags" type={"Array"}
                            caption={i18n.t("customers.grid.columnlabeltags")}>
                        </Column>

                        <Column dataField="status"
                            caption={
                                i18n.t("customers.grid.columnlabelstatus")
                            }
                            cellRender={
                                this.setStatus
                            }
                            editCellRender={
                                this.renderSwitch
                            } >
                            <HeaderFilter dataSource={this.statusHeaderFilter} />
                        </Column>

                        <Column dataField="createdAt"
                            caption={
                                i18n.t("customers.grid.columnlabelcreatedat")
                            }
                            dataType="date"
                            calculateCellValue={
                                this.calculateCellValue2
                            } />

                        <Template name="totalGroupCount"
                            render={
                                this.toolbarItemRender
                            } />
                        <Export enabled={true}
                            allowExportSelectedData={false}
                            fileName="TooWeze_Customers" />
                    </DataGrid>
                )}

            </div>
        );
    }
}

export default withRouter(ReportsViewMiddle);
